export default __webpack_public_path__ + "static/media/nine.d38f2eea.png";